import {Utils} from '../src/core/utils';
import ListSubmenuOverlay from '../src/listsubmenuoverlay';

import 'jquery';
import 'gsap';
import 'ScrollMagic';
import 'ScrollMagic.animation.gsap';
import 'ScrollMagic.debug.addIndicators';
import 'modernizr';
import 'fancy';
import 'fancy.thumbs';
import 'cycle2';
import 'cycle2-center';
import 'cycle2-swipe';
import 'cycle2-carousel';

/**
 * Configurazioni generali condivise fra tutte le pagina del sito:
 * - Lingua
 * - Menu
 * - Header
 * - ecc...
 */

export default function commons(app) {
    // Run setups
    $(document).ready(function() {
        /**
         *
         * Costanti e variabili comuni alle funzioni
         *
         */
        // GENERAL
        const $window = Utils.shared().window();
        var winWidth = $window.width();
        var winHeight = $window.height();
        var scrollVal = $window.scrollTop();

        //HEADER LOGO
        const $logo = $('#logo');
        const $payoff = $('#payoff');

        //NAV MAIN
        const $navMain = $('#navMain');
        const $navMainBtn = $('#navMainBtn');

        // ELEMENTS
        const $header = $('#header');
        const $topLineSxHeader = $('#topLineSxHeader');
        const $topLineDxHeader = $('#topLineDxHeader');

        // SETUP PAGINA
        function setup(app) {

            fxSet();
            headerHandler();
            navMainHandler();
            fancyboxHandler();

            $window.resize(function(){

                winWidth = $window.width();
                winHeight = $window.height();

                headerHandler();

            });

            $window.scroll(function () {

                scrollVal = $window.scrollTop();

                headerHandler();

            });

            if ( ! Modernizr.objectfit )
            {
                $('.cover').each(function () {
                    var $container = $(this),
                        imgUrl = $container.find('img').prop('src');
                    if (imgUrl) {
                        $container
                            .css('backgroundImage', 'url(' + imgUrl + ')')
                            .addClass('ObjectFitCover');
                    }
                });

                $('.contain').each(function () {
                    var $container = $(this),
                        imgUrl = $container.find('img').prop('src');
                    if (imgUrl) {
                        $container
                            .css('backgroundImage', 'url(' + imgUrl + ')')
                            .addClass('ObjectFitContain');
                    }
                });
            }
        }

        /**********************************************/
        //
        // HEADER
        //
        /**********************************************/
        function headerHandler()
        {
            if (scrollVal > 50) {

                $header.addClass('scrolled');
            }
            else
            {
                $header.removeClass('scrolled');
            }
        }


        /**********************************************/
        //
        // NAV MAIN
        //
        /**********************************************/
        function navMainHandler()
        {
            $navMainBtn.addClass('open');

            $navMainBtn.click(function(){

                if($navMain.hasClass('open'))
                {
                    if(winWidth > 767)
                    {
                        $topLineDxHeader.animate({
                            height: '100%'
                        }, 800);
                    }

                    $navMain.removeClass('open');
                    $navMainBtn.removeClass('close');

                    $navMainBtn.addClass('open');

                    setTimeout(function(){
                        $topLineSxHeader.animate({
                            height: '100%'
                        }, 800);
                    }, 800);
                }
                else
                {
                    $navMainBtn.removeClass('open');

                    $topLineSxHeader.animate({
                        height: '100vh'
                    }, 500, function() {

                        $navMain.addClass('open');
                        $navMainBtn.addClass('close');

                        if (winWidth > 767)
                        {
                            $topLineDxHeader.animate({
                                height: '100vh'
                            }, 800);
                        }

                    });
                }
            });
        }


        /**********************************************/
        //
        // FANCYBOX
        //
        /**********************************************/

        // Gestore fancybox
        function fancyboxHandler()
        {
            $(".fancybox").fancybox({
                padding     : 0,
                prevEffect	: 'fade',
                nextEffect	: 'fade',
                helpers	: {
                    thumbs	: {
                        width	: 50,
                        height	: 50
                    }
                }
            });
        }

        /**********************************************/
        //
        // FX GENERAL
        //
        /**********************************************/
        var tl;

        function fxSet()
        {
            // effetti al caricamento della pagina
            tl = new TimelineMax();

            // Start Fx elementi
            app.fx.debug = false;
            app.fx.runParallaxElement();
            app.fx.runSlideIn();
            app.fx.runFadeIn();

            tl.set($logo, {left: '-100%'})
              .set($payoff, {left: '-100%'});

            tl.to($logo, 0.2, {left: 0, ease: Power2.easeOut})
              .to($payoff, 0.5, {left: 0, ease: Power2.easeOut});
        }

        setup(app);

    });

}


/** WEBPACK FOOTER **
 ** ./assets/scripts/views/commons.js
 **/